import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop as MuiBackdrop, } from '@mui/material';
export function Backdrop({ open, children }) {
    return (_jsx(MuiBackdrop, { open: open, sx: () => ({ zIndex: 1000 }), children: children }));
}
